module.exports = __webpack_public_path__ + "media/images/icons/email-52d8421980490966996952de90e75942.svg";